import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseConfig } from './../../../../shared/service/base-config.service';
import { GenericHttpService } from './../../../../shared/service/generic-http.service';
import { DadosOnInitModelView, SaldoDevedorMunicipioModelView, SaldoDevedorMunicipioFiltro,  } from './../model/saldoDevedorMunicipio.model';
import { ExportTypes } from '../../../../shared/enum/TypeExportReportEnums';

@Injectable()
export class SaldoDevedorMunicipioService {
  private readonly urlBase: string;

  constructor(
    private baseConfig: BaseConfig,
    private readonly http: GenericHttpService<any>) {
  }

  public dadosOnInitFormulario (): Observable<DadosOnInitModelView> {

    let retorno: Observable<DadosOnInitModelView> = null;

    retorno = this.http.getAny(this.baseConfig.getBaseUrlApi().concat('/consulta/SaldoDevedorMunicipio/DadosOnInitFormulario'), null);

    return retorno;
  }

  public consultarSaldoDevedorMunicipio(filtro : SaldoDevedorMunicipioFiltro ): Observable<SaldoDevedorMunicipioModelView> {

    let retorno: Observable<SaldoDevedorMunicipioModelView> = null;

    retorno = this.http.post(this.baseConfig.getBaseUrlApi().concat('/consulta/SaldoDevedorMunicipio/ConsultarSaldoDevedor'), filtro);

    return retorno;
  }

  public gerarRelatorioSaldoDevedorMunicipio(filtro: SaldoDevedorMunicipioFiltro, tipoRel: ExportTypes): Observable<Blob>{

    const url = this.baseConfig.getBaseUrlApi().concat('/consulta/SaldoDevedorMunicipio/GerarRelatorioSaldoDevedor');
    return this.http.report(url, filtro,tipoRel);
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/saldo-devedor-municipio/shared/service/saldoDevedorMunicipio.service.ts